import { isProdEnv } from '@vfde-sails/utils';
import { DXL_PREPROD, DXL_PROD } from '@vfde-sails/constants';
import { ApiKey, Endpoint } from '../enum';

export const getRequestURL = (endpoint: Endpoint): URL =>
    new URL(endpoint, isProdEnv() ? DXL_PROD : DXL_PREPROD);

export const getRequestApiKey = (): ApiKey =>
    isProdEnv() ? ApiKey.API_VF : ApiKey.PRE_PROD_API;
